// Servizio Account & Sicurezza (2FA TOTP + Passkey/WebAuthn).
// Riusa l'istanza axios centrale (Bearer + refresh) tramite `client.js`.
import { api, unwrap } from './client';

/**
 * Autenticazione a due fattori (TOTP) — endpoint backend `/account/2fa/*`.
 * Disponibile per qualsiasi utente autenticato (customer, admin, ecc.).
 */
export const twoFactorService = {
  /** Stato 2FA dell'utente loggato: { enabled }. */
  status: () => unwrap(api.get('/account/2fa/status')),

  /** Avvia la configurazione: ritorna { secret, otpauth_url, qr_code, recovery_codes }. */
  setup: () => unwrap(api.post('/account/2fa/setup')),

  /** Conferma e attiva la 2FA verificando un codice TOTP. */
  enable: (code) => unwrap(api.post('/account/2fa/enable', { code })),

  /** Disattiva la 2FA (richiede la password dell'account). */
  disable: (password) => unwrap(api.post('/account/2fa/disable', { password })),
};

export default twoFactorService;

/**
 * Passkey / WebAuthn — endpoint backend `/webauthn/*` (gestione, autenticato)
 * e `/auth/webauthn/*` (login passwordless, pubblico).
 */
export const passkeyService = {
  /** Avvia la registrazione di una nuova passkey (utente loggato). */
  registerBegin: () => unwrap(api.post('/webauthn/register/begin', { origin: window.location.origin })),

  /** Completa la registrazione inviando la credenziale prodotta dall'autenticatore. */
  registerComplete: (body) => unwrap(api.post('/webauthn/register/complete', body)),

  /** Elenco delle passkey registrate dall'utente. */
  list: () => unwrap(api.get('/webauthn/credentials')),

  /** Rimuove una passkey. */
  remove: (id) => unwrap(api.delete(`/webauthn/credentials/${id}`)),

  /** Avvia il login con passkey (email opzionale). */
  loginBegin: (email) => unwrap(api.post('/auth/webauthn/login/begin', {
    origin: window.location.origin,
    ...(email ? { email } : {}),
  })),

  /** Completa il login con passkey → ritorna { user, access_token, refresh_token }. */
  loginComplete: (body) => unwrap(api.post('/auth/webauthn/login/complete', body)),
};
